module.exports = __webpack_public_path__ + "media/charles.5375cba9.mp3";